// src/components/DarkModeToggle.js
import { useContext, useEffect } from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import "../styles/darkmode.css";
import { AuthContext } from "../context/AuthContext";

const DarkModeToggle = () => {
  const { isDarkMode, setIsDarkMode } = useContext(AuthContext);

  // Ensure theme is applied correctly on mount
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark-theme");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark-theme");
      localStorage.setItem("theme", "light");
    }
  }, [isDarkMode]);

  return (
    <label className="dark-toggle-slider" title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}>
      <input
        type="checkbox"
        checked={isDarkMode}
        onChange={() => setIsDarkMode(!isDarkMode)}
      />
      <span className="slider-icon">
        {isDarkMode ? <FaSun size={14} /> : <FaMoon size={14} />}
      </span>
    </label>
  );
};

export default DarkModeToggle;
